import { render } from "./register-result.vue?vue&type=template&id=c80510e2"
import script from "./register-result.vue?vue&type=script&lang=ts"
export * from "./register-result.vue?vue&type=script&lang=ts"
script.render = render

export default script